import { lazyLoad } from 'utils/loadable';

export const AdminAppsPage = lazyLoad(
  () => import('./index'),
  module => module.AdminAppsPage,
);
